//#region src/client/internal/fetcher-merge.ts
/**
* Merge two fetcher configurations, with user config taking precedence.
* If user provides a custom function, it takes full precedence.
* Otherwise, deep merge RequestInit options.
*/
function mergeFetcherConfigs(authorConfig, userConfig) {
	if (userConfig?.type === "function") return userConfig;
	if (!userConfig && authorConfig?.type === "function") return authorConfig;
	const authorOpts = authorConfig?.type === "options" ? authorConfig.options : {};
	const userOpts = userConfig?.type === "options" ? userConfig.options : {};
	if (Object.keys(authorOpts).length === 0 && Object.keys(userOpts).length === 0) return;
	return {
		type: "options",
		options: {
			...authorOpts,
			...userOpts,
			headers: mergeHeaders(authorOpts.headers, userOpts.headers)
		}
	};
}
/**
* Merge headers from author and user configs.
* User headers override author headers.
*/
function mergeHeaders(author, user) {
	if (!author && !user) return;
	const merged = new Headers(author);
	new Headers(user).forEach((value, key) => merged.set(key, value));
	if (merged.keys().next().done) return;
	return merged;
}

//#endregion
export { mergeFetcherConfigs };
//# sourceMappingURL=fetcher-merge.js.map